import React, { useState,useEffect } from 'react';


import HeaderMenuProfile from '../../header/HeaderMenuProfile.js';

import UserService from '../../../../class/User/UserService';
import UserServices from '../../../../class/User_copy/UserService';

import AuthService from '../../../../class/services/AuthService';

import Document from './account_setting_comm/document.js';

import Mobile from './account_setting_comm/mobile.js';



import Password from './account_setting_comm/password.js';


import Privacy from './account_setting_comm/privacy.js';

import LimitDay from './account_setting_comm/limitday.js';

import AccessHistory from './account_setting_comm/access_history.js';


import Suspend from './account_setting_comm/suspend.js';

import Twofactor from './account_setting_comm/2fa.js';



import CashHistory from './cash_history.js';

const AccountSetting = () => {





  return (
    <div className="col-10">

        {/* {<Document UserService={UserService} AuthService={AuthService} />} */}

        {/* <Mobile UserService={UserService} AuthService={AuthService} /> */}

        {/* <Password UserService={UserService} AuthService={AuthService} /> */}

        {/* <Privacy  UserService={UserService} AuthService={AuthService} /> */}

        {/* <LimitDay UserService={UserService} AuthService={AuthService} /> */}

        {/* <Suspend UserService={UserService} AuthService={AuthService} /> */}
        
        {/* <Twofactor UserService={UserService} AuthService={AuthService} /> */}
        
        

        <AccessHistory UserServices={UserServices} AuthService={AuthService} />

      

    </div>
  );
};

export default AccountSetting;
